<template>
  <div>
    <v-dialog persistent max-width="500" v-model="olahDataDialog">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          {{ olahDataTitle }}
        </v-card-title>

        <v-divider class="mx-5"></v-divider>

        <v-card-text class="pb-0 mt-3">
          <v-form ref="form" v-model="valid">
            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Nama Tipe Gudang
            </v-card-title>
            <v-text-field
              v-model="olahData.name"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0 pb-5">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#61B15A"
            style="text-transform: unset !important"
            @click="closeOlahData"
          >
            Batal
          </v-btn>
          <v-btn
            color="#61B15A"
            class="white--text"
            style="text-transform: unset !important"
            @click="checkType"
            :disabled="!valid"
            :loading="loading"
          >
            {{ olahDataBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="popDialog" width="500">
      <v-card color="red" rounded>
        <v-card-title class="text-h6 white--text">
          Data tipe gudang gagal ditambahkan. Periksa kembali data anda !!
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="light-green darken-1"
            class="white--text"
            @click="closePopDialog"
            >Tutup</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    olahDataDialog: Boolean,
    typeAction: String,
    olahDataTitle: String,
    olahDataBtn: String,
    olahData: Object,
  },
  data: () => ({
    valid: false,
    loading: false,
    popDialog: false,
    rules: {
      required: (value) => !!value || "Tidak boleh kosong !!",
    },
  }),
  methods: {
    checkType() {
      this.olahData.name = this.olahData.name.replace(/\b\w/g, (c) =>
        c.toUpperCase()
      );
      this.loading = true;
      if (this.typeAction === "edit") {
        this.edit();
      } else if (this.typeAction === "new") {
        this.new();
      }
    },
    new() {
      const data = JSON.stringify(this.olahData);
      axios
        .post("v1/admin/gudang_type", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          this.loading = false;
          this.$emit("reloadData");
          this.closeOlahData();
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            this.popDialog = true;
          }
        });
    },
    edit() {
      const data = JSON.stringify(this.olahData);
      axios
        .put("v1/admin/gudang_type", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            this.loading = false;
            this.$emit("reloadData");
            this.closeOlahData();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    closeOlahData() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("closeOlahDataDialog");
    },
    closePopDialog() {
      this.popDialog = false;
    },
  },
};
</script>